export default __webpack_public_path__ + "static/media/image2pro6.0f5ecdd8.jpeg";